<template>
  <el-dialog class="rightDetailModal" :visible.sync="modalInfo.isShow" v-if="modalInfo.isShow" width="40%">
     <div slot="title" class="dialog-title">
        <div class="detail-title">{{modalInfo.detail.itemtitle}}</div>
        <h4 class="shop-title" style="font-size:18px;margin:16px 0;" :class='"shop-img-"+modalInfo.detail.platform'>{{modalInfo.detail.shopname}}
            <img class="img" :src="require('@/assets/img/platform/pla_'+modalInfo.detail.platform+'.png')"/>
        </h4>
     </div>
     <el-timeline v-loading="loading" style="margin-top:20px;">
        <el-timeline-item v-for="(item,i) in modalInfo.infoList" :key="i" :class="modalInfo.infoList.length<2?'last':''" :timestamp="item.createtime|fullTime" placement="top">
            <el-card>
                <p>已通知次数：<span>{{item.noticeNumber}}次</span></p>
                <p>整改状态：<span>{{item.status == 0 ? '未整改':'已整改'}}</span></p>
                <p>整改说明：<span>{{item.instructions}}</span></p>
                <p v-if="item.priceStandard">改价标准：<span>￥{{item.priceStandard}}</span></p>
                <div v-if="item.screenshots.length>0&&item.screenshots[0].trim()">截图：
                    <div class="img-list">
                        <viewer :images="item.screenshots">
                            <li v-for="(img,index) in item.screenshots" v-show="img.trim()" :key="index"><img :src="img" alt=""></li>
                        </viewer>
                    </div>
                </div>
            </el-card>
        </el-timeline-item>
    </el-timeline>
  </el-dialog>
</template>
<script>
export default {
    name:'detailModel',
    props:{
        modalInfo:{
            type:Object,
            default:() =>{}
        }
    },
    data(){
        return {
            loading:true
        }
    }
}
</script>
<style lang="scss">
 
.rightDetailModal{
    .el-dialog__header{
        box-shadow: 0 3px 3px #eee;
        min-height: 24px;
    }
    .last .el-timeline-item__tail{
        display: none;
    }
}
.viewer-container{
    z-index: 2600;
}
</style>


